import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { apiUrl } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FeriaService {
  storage = null;
  accessToken = '';
  headers = {};
  constructor(private http: HttpClient) {
    this.storage = localStorage.getItem('at');

    if (this.storage) {
      const decode = atob(this.storage);
      this.accessToken = JSON.parse(decode);
    }

    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };
  }

  addFeria(data: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'add_fe',
        data: data,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/marketplaces`, body);
  }

  getFerias(id_usuario: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'get_all_fe',
        data: { id_usuario_feria: id_usuario },
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/marketplaces`, body);
  }
}
